export const toggleIcon = {
  name: 'toggleIcon',
  svg: `<svg width="6" height="6" viewBox="0 0 6 6" xmlns="http://www.w3.org/2000/svg">
<path d="M6 0L0 6H6V0Z"/>
</svg>
`,
};
